import _regeneratorRuntime from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _objectSpread from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { HeaderNames } from "./HeaderNames";
import { LogLevel } from "./ILogger";
import { TransferFormat } from "./ITransport";
import { Arg, getDataDetail, getUserAgentHeader, Platform } from "./Utils";
/** @private */

export var WebSocketTransport =
/*#__PURE__*/
function () {
  function WebSocketTransport(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers) {
    _classCallCheck(this, WebSocketTransport);

    this._logger = logger;
    this._accessTokenFactory = accessTokenFactory;
    this._logMessageContent = logMessageContent;
    this._webSocketConstructor = webSocketConstructor;
    this._httpClient = httpClient;
    this.onreceive = null;
    this.onclose = null;
    this._headers = headers;
  }

  _createClass(WebSocketTransport, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(url, transferFormat) {
        var _this = this;

        var token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Arg.isRequired(url, "url");
                Arg.isRequired(transferFormat, "transferFormat");
                Arg.isIn(transferFormat, TransferFormat, "transferFormat");

                this._logger.log(LogLevel.Trace, "(WebSockets transport) Connecting.");

                if (!this._accessTokenFactory) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return this._accessTokenFactory();

              case 7:
                token = _context.sent;

                if (token) {
                  url += (url.indexOf("?") < 0 ? "?" : "&") + "access_token=".concat(encodeURIComponent(token));
                }

              case 9:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  url = url.replace(/^http/, "ws");
                  var webSocket;

                  var cookies = _this._httpClient.getCookieString(url);

                  var opened = false;

                  if (Platform.isNode) {
                    var headers = {};

                    var _getUserAgentHeader = getUserAgentHeader(),
                        _getUserAgentHeader2 = _slicedToArray(_getUserAgentHeader, 2),
                        name = _getUserAgentHeader2[0],
                        value = _getUserAgentHeader2[1];

                    headers[name] = value;

                    if (cookies) {
                      headers[HeaderNames.Cookie] = "".concat(cookies);
                    } // Only pass headers when in non-browser environments


                    webSocket = new _this._webSocketConstructor(url, undefined, {
                      headers: _objectSpread({}, headers, _this._headers)
                    });
                  }

                  if (!webSocket) {
                    // Chrome is not happy with passing 'undefined' as protocol
                    webSocket = new _this._webSocketConstructor(url);
                  }

                  if (transferFormat === TransferFormat.Binary) {
                    webSocket.binaryType = "arraybuffer";
                  }

                  webSocket.onopen = function (_event) {
                    _this._logger.log(LogLevel.Information, "WebSocket connected to ".concat(url, "."));

                    _this._webSocket = webSocket;
                    opened = true;
                    resolve();
                  };

                  webSocket.onerror = function (event) {
                    var error = null; // ErrorEvent is a browser only type we need to check if the type exists before using it

                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                      error = event.error;
                    } else {
                      error = "There was an error with the transport";
                    }

                    _this._logger.log(LogLevel.Information, "(WebSockets transport) ".concat(error, "."));
                  };

                  webSocket.onmessage = function (message) {
                    _this._logger.log(LogLevel.Trace, "(WebSockets transport) data received. ".concat(getDataDetail(message.data, _this._logMessageContent), "."));

                    if (_this.onreceive) {
                      try {
                        _this.onreceive(message.data);
                      } catch (error) {
                        _this._close(error);

                        return;
                      }
                    }
                  };

                  webSocket.onclose = function (event) {
                    // Don't call close handler if connection was never established
                    // We'll reject the connect call instead
                    if (opened) {
                      _this._close(event);
                    } else {
                      var error = null; // ErrorEvent is a browser only type we need to check if the type exists before using it

                      if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                        error = event.error;
                      } else {
                        error = "WebSocket failed to connect. The connection could not be found on the server," + " either the endpoint may not be a SignalR endpoint," + " the connection ID is not present on the server, or there is a proxy blocking WebSockets." + " If you have multiple servers check that sticky sessions are enabled.";
                      }

                      reject(new Error(error));
                    }
                  };
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect(_x, _x2) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "send",
    value: function send(data) {
      if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
        this._logger.log(LogLevel.Trace, "(WebSockets transport) sending data. ".concat(getDataDetail(data, this._logMessageContent), "."));

        this._webSocket.send(data);

        return Promise.resolve();
      }

      return Promise.reject("WebSocket is not in the OPEN state");
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._webSocket) {
        // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
        // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
        this._close(undefined);
      }

      return Promise.resolve();
    }
  }, {
    key: "_close",
    value: function _close(event) {
      // webSocket will be null if the transport did not start successfully
      if (this._webSocket) {
        // Clear websocket handlers because we are considering the socket closed now
        this._webSocket.onclose = function () {};

        this._webSocket.onmessage = function () {};

        this._webSocket.onerror = function () {};

        this._webSocket.close();

        this._webSocket = undefined;
      }

      this._logger.log(LogLevel.Trace, "(WebSockets transport) socket closed.");

      if (this.onclose) {
        if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) {
          this.onclose(new Error("WebSocket closed with status code: ".concat(event.code, " (").concat(event.reason || "no reason given", ").")));
        } else if (event instanceof Error) {
          this.onclose(event);
        } else {
          this.onclose();
        }
      }
    }
  }, {
    key: "_isCloseEvent",
    value: function _isCloseEvent(event) {
      return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    }
  }]);

  return WebSocketTransport;
}();